import { SEARCH_API_URL } from './env-vars';
import { SearchRequest, SearchResponse } from './types';

export const search = async (
  params: SearchRequest
): Promise<SearchResponse> => {
  try {
    const response = await fetch(`${SEARCH_API_URL.get()}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error(`Search failed with status ${response.status}`);
    }

    const data = await response.json();

    // Ensure compatibility by adding objectID if missing (useful if we still pass these to components expecting Algolia structure)
    const hits = (data.hits || []).map((hit: any) => ({
      ...hit,
      objectID: hit.id?.toString() || hit.objectID,
    }));

    return {
      total: data.total || 0,
      hits,
    };
  } catch (error) {
    console.error('Search API error:', error);
    return { total: 0, hits: [] };
  }
};
